import React, { Component } from 'react';
import Link from 'gatsby-link'
import NavBar from '../components/navBar'
import BourbonTaste34 from '../assets/images/BB_Bourbon-34.jpg'
import BrandLogoMobile from '../assets/images/BrandLogoMobile.png'
import MobileImg from '../assets/images/BourbonPartyHeaderMobile.png'

import { withPrefix } from "gatsby-link";

const Header = ({ location }) => {
    return (
        <div>
            <section className="hero is-fullheight video is-hidden-mobile is-dark">
                <div className="hero-video">
                    <div className="embed-container">
                        <iframe src="https://player.vimeo.com/video/291218348?background=1" width="100%" height="100%" frameBorder="0" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe>
                    </div> 
                </div>
                <div className="hero-head">
                <NavBar />
                </div>
                <div className="hero-body">
                    <div className="container">
                        <div className="columns is-centered">
                            <div className="column is-half header-pitch has-text-centered has-text-white">
                                <h2>Curated Party in a Box</h2>
                                <p>Everything you need to throw a party they'll remember.</p>
                                <div className="has-text-centered m-t-lg">
                                    <a href="https://backyardbundles.myshopify.com/collections/bourbon-party-bundles" className="button is-primary is-medium">Buy A Bundle</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hero-foot">
                    <div className="has-text-centered has-text-white">
                    </div>
                </div>
                
            </section>
            <section className="hero is-hidden-tablet">
                <div className="columns">
                    <div className="column">
                        <img src={BrandLogoMobile} />
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <figure className="image is-3x2">
                            <img src={MobileImg} />
                        </figure>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Header


// WEBPACK FOOTER //
// ./src/components/header.jsx